// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fNkK","title":"Header_title__3TRo_","side":"Header_side__3d-SA"};